module.exports = __webpack_public_path__ + "img/fanyuan_11.6009c00f.png";